import React from 'react';
import MobileMenuItem from './MobileMenuItem';

const MobileNavigation = ({closeMenu}) => {
    const menuItems = [
        { id: 1, text: 'Home', link: '/', children: [] },
        { id: 2, text: 'About Us', link: '/about_us', children: [] },
        { id: 3, text: 'Services', link: '#', children: [
            { id: 11, text: 'Projects Management', link: '/service/projects_management' },
            { id: 12, text: 'Management Consultancy', link: '/service/management_consultancy' },
            { id: 13, text: 'Arbitrary and Legal Services', link: '/service/arbitrary_&_legal' }
        ] },
        { id: 4, text: 'Projects', link: '/projects', children: [] },
        { id: 5, text: 'Contact', link: '/contact_us', children: [] },
        // Add more menu items here
    ];

    return (
        <nav className="qodef-mobile-header-navigation" role="navigation" aria-label="Mobile Menu" style={{display:"block"}}>
            <ul id="menu-main-menu-4">
                {menuItems.map(item => (
                    <MobileMenuItem key={item.id} item={item} closeMenu={closeMenu} />
                ))}
            </ul>
        </nav>
    );
};

export default MobileNavigation;